// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"84b75d43","213":"0c8f1caa","219":"a11411ed","445":"8da6ac29","453":"d1fa110c","547":"865cfd4e","624":"c006061e","676":"85f3d22a","732":"74d40df9","824":"6c721a7a","868":"2dbb451c"}[chunkId] + ".chunk.js";
};